// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Belt_Int = require("rescript/lib/js/belt_Int.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Expln_React_Row = require("../../rescript-utils/main/react-mui-components/Expln_React_Row.res.js");
var MM_react_common = require("./MM_react_common.res.js");
var Expln_React_common = require("../../rescript-utils/main/Expln_React_common.res.js");
var TextField = require("@mui/material/TextField").default;
var Pagination = require("@mui/material/Pagination").default;

var nonDigitPattern = /\D/g;

function PaginationCmp(props) {
  var __itemPerPageText = props.itemPerPageText;
  var onItemsPerPageChange = props.onItemsPerPageChange;
  var onPageIdxChange = props.onPageIdxChange;
  var __showItemsPerPage = props.showItemsPerPage;
  var __showGoToPage = props.showGoToPage;
  var __itemsPerPage = props.itemsPerPage;
  var numOfPages = props.numOfPages;
  var itemsPerPage = __itemsPerPage !== undefined ? __itemsPerPage : 0;
  var showGoToPage = __showGoToPage !== undefined ? __showGoToPage : false;
  var showItemsPerPage = __showItemsPerPage !== undefined ? __showItemsPerPage : false;
  var itemPerPageText = __itemPerPageText !== undefined ? __itemPerPageText : "";
  var match = React.useState(function () {
        return "";
      });
  var setGoToPageText = match[1];
  var goToPageText = match[0];
  var match$1 = React.useState(function () {
        
      });
  var setItemsPerPageText = match$1[1];
  var itemsPerPageTextEffective = Belt_Option.getWithDefault(match$1[0], String(itemsPerPage));
  var actChangePage = function (newPageNum) {
    if (1 <= newPageNum && newPageNum <= numOfPages) {
      setGoToPageText(function (param) {
            return "";
          });
      return onPageIdxChange(newPageNum - 1 | 0);
    }
    
  };
  var actGoToPage = function () {
    var newPageNum = Belt_Int.fromString(goToPageText);
    if (newPageNum !== undefined) {
      return actChangePage(newPageNum);
    }
    
  };
  var actChangeItemsPerPage = function () {
    var newItemsPerPage = Belt_Int.fromString(itemsPerPageTextEffective);
    if (newItemsPerPage !== undefined) {
      if (onItemsPerPageChange !== undefined) {
        onItemsPerPageChange(newItemsPerPage);
      }
      return setItemsPerPageText(function (param) {
                  
                });
    }
    
  };
  return React.createElement(Expln_React_Row.make, {
              alignItems: "center",
              children: Caml_option.some(null)
            }, React.createElement(Pagination, {
                  count: numOfPages,
                  page: props.pageIdx + 1 | 0,
                  siblingCount: props.siblingCount,
                  onChange: (function (param, newPage) {
                      actChangePage(newPage);
                    })
                }), itemPerPageText, showItemsPerPage ? React.createElement("input", {
                    size: 3,
                    type: "text",
                    value: itemsPerPageTextEffective,
                    onKeyDown: MM_react_common.kbrdHnd(MM_react_common.keyEnter, undefined, undefined, undefined, actChangeItemsPerPage),
                    onChange: Expln_React_common.evt2str(function (newItemsPerPage) {
                          setItemsPerPageText(function (param) {
                                return newItemsPerPage.replace(nonDigitPattern, "");
                              });
                        })
                  }) : null, showGoToPage ? React.createElement(TextField, {
                    value: goToPageText,
                    label: "Go to page",
                    size: "small",
                    style: {
                      width: "150px"
                    },
                    onChange: Expln_React_common.evt2str(function (newPage) {
                          setGoToPageText(function (param) {
                                return newPage.replace(nonDigitPattern, "");
                              });
                        }),
                    onKeyDown: MM_react_common.kbrdHnd(MM_react_common.keyEnter, undefined, undefined, undefined, actGoToPage)
                  }) : null);
}

var make = PaginationCmp;

exports.nonDigitPattern = nonDigitPattern;
exports.make = make;
/* react Not a pure module */
